<template>
  <CurrencyFormSearch
    v-model="modelValue"
    :data-refid="dataRefid"
    :instance
    :disabled
    :label
    :size
    :error
    :silent
    @select="handleSelect"
    @ready="handleReady"
  />
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue'

import { InputSize } from '@types'
import { AssetClass } from '..'

import { ASSET_FIELD } from '../utils/const'

import CurrencyFormSearch from './CurrencyFormSearch.vue'

type Props = {
  instance: AssetClass
  disabled?: boolean
  label?: string
  focusOnLoad?: boolean
  dataRefid?: string
  size?: InputSize
}

const props = defineProps<Props>()

const modelValue = props.instance.field<string>(ASSET_FIELD.CURRENCY)

const isSavedAsset = inject('isSavedAsset', ref(false))

const error = computed(() => props.instance.errors.currency)
const silent = computed(() => !isSavedAsset.value)

const handleSelect = (_: string, ticker: string) => {
  modelValue.value = ticker
}

const handleReady = (el: HTMLInputElement) => {
  if (!props.focusOnLoad) return
  el.focus()
}
</script>
